import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getBanners} from '../../store/reducers';
import ArrowDown from 'react-icons/lib/io/ios-arrow-down'
import MainMenuIcon from 'react-icons/lib/md/view-headline'
import jump from 'jump.js'
import style from './style.css';

class HomeBanner extends Component {

    constructor(props){//{{{
        super(props)
        this.state = { bg_loaded: false }
        this.photo_banner = this.photo_banner.bind(this)
        this.photo_size = this.photo_size.bind(this)
        this.on_bg_load = this.on_bg_load.bind(this)
        this.blurry_background = this.blurry_background.bind(this)
        this.collapse_main_menu = this.collapse_main_menu.bind(this)
        this.toggle_main_menu = this.toggle_main_menu.bind(this)
        this.show_main_menu = this.show_main_menu.bind(this)
    
    }//}}}
    on_bg_load(){//{{{
      //console.log("BAckground image has been loaded")
        this.setState({...this.state, bg_loaded: true})   
        const me = this
        //setTimeout(() => { me.collapse_main_menu() }, 1000 )
    }//}}}
    toggle_main_menu(){//{{{
        this.setState({...this.state, main_menu: !this.state.main_menu})
    }//}}}
    collapse_main_menu(){//{{{
        this.setState({...this.state, main_menu: false})
    }//}}}
    show_main_menu(){//{{{
        this.setState({...this.state, main_menu: true})
    }//}}}
    photo_banner(){//{{{
      return `/cover.jpg`
    }//}}}
    photo_size(photo, size){//{{{
        return photo.replace("medium",size)
    }//}}}
    blurry_background(){//{{{
        if( this.state.bg_loaded === false ){ 
            return true
        }
        return false
    }//}}}


    render() {
        const is_landscape = this.props.browser && this.props.browser.orientation==="landscape"
        const is_large = this.props.browser.greaterThan.small
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const windowWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
        let {photo_size, photo_banner, blurry_background} = this
        return (
            <div style={{ height: '100vh' }} className={ `${ style.homeBanner } ${ false ? style.resortHome : ''}` }>
                <div className={ [style.bg, ( blurry_background() ? style.blurred : '') ].join(" ") } style={{ width: is_landscape ? "100vw" : "100vw", height: '100vh', backgroundImage: `url('${ photo_size(photo_banner(), this.state.bg_loaded ? "gallery" : "small") }')`, transform: is_landscape ? "" : 'translateXX(-50%)'}}  ></div>
                <img src={ photo_size(photo_banner(),"gallery") } onLoad={ this.on_bg_load } style={{ display: 'none'}}/>
                <div className={ style.fade }></div>
                { null &&
                <img src={ `/logo.png` } className={ style.logo }/> }
                <div className={ style.explore } onClick={ () => { jump(windowHeight - (false ? 0 : 150)) }}>
                    <ArrowDown className={ [style.arrow, style.bounce].join(" ")} /> 
                </div>
            </div>
        )
    }
}
export default withRouter(connect( 
    state => ({
        browser: state.browser
    })
)(HomeBanner));



// WEBPACK FOOTER //
// ./src/components/homebanner/index.js